import {CommonService} from "./common/commonService";
import { ServicesConfig } from "./servicesConfig";

export class UserService{

    static getUser = () => (
        CommonService.get("/user/loggedUser")
    )

    static getUsers = () => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/users")
    )
}